// src/app/auth/token.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AccountService } from '../services/account.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    public accountService: AccountService,
    private router: Router,
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.accountService.getToken()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.accountService.getToken()}`,
        },
      });
    }
    // return next.handle(request);
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        //if (event instanceof HttpResponse) {
        //  console.log('event--->>>', event);
        //}
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.router.navigate(['/login'], { queryParams: { returnUrl: request.urlWithParams } });
        }
        return throwError(error && error.error.reason ? error.error.reason : '');
      }),
    );
  }
}
